export class Output {
  public output: boolean;
  public socket: any;
  constructor() {
    this.output = true;
    this.socket = {};
  }
}
